var React = require('react');

function IconCaret (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.3662 0.665443C9.20344 0.665443 9.04695 0.735018 8.92175 0.86721L4.99687 5.24347L1.06573 0.874167C0.821596 0.602825 0.42723 0.602825 0.183099 0.874167C-0.0610329 1.14551 -0.0610329 1.58383 0.183099 1.85517L4.55869 6.71846C4.79656 6.98284 5.2097 6.98284 5.44131 6.71846L9.8169 1.85517C10.061 1.58383 10.061 1.14551 9.8169 0.874168C9.68545 0.735017 9.52895 0.665443 9.3662 0.665443Z"}));
}

IconCaret.defaultProps = {"viewBox":"0 0 10 7","fill":"none"};

module.exports = IconCaret;

IconCaret.default = IconCaret;
